import MutateMessage from 'utils/mutate/message'
import _ from 'lodash'
import FetchCachedMessage from 'utils/fetch/cached/FetchCachedMessage'
import { constantsActive } from 'utils/constants/constants'

export const mutateArchiveOne = ( guid ) => {
	MutateMessage.archive( guid, {
		callbackSuccess: ( { message } ) => {
			FetchCachedMessage.reload();
		}
	})
}

export const mutateReadOne = ( guid ) => {
	MutateMessage.setReadyBy( [ guid ], {
		callbackSuccess: ( { messages } ) => {
			FetchCachedMessage.reload();
		}
	});
}

export const mutateReadAll = ( originalMessages ) => {
	const messagesUnread = _.filter( originalMessages, { is_read: constantsActive.NO } );
	if( _.size( messagesUnread ) > 0 ) {
		const messageGuids = _.map( messagesUnread, o => {
			return o.guid;
		} );
		
		MutateMessage.setReadyBy( messageGuids, {
			callbackSuccess: ( { messages } ) => {
				FetchCachedMessage.reload();
			}
		});
	}
}